<template>
  <div id="sidebar-menu" class="d-flex">
    <!-- {{layoutobject}} fdsfdsf{{[layoutobject.split(' ').includes('horizontal-wrapper')]}} -->
    <ul
      class="sidebar-links custom-scrollbar"
      id="myDIV"
      :style="[
        layoutobject.split(' ').includes('horizontal-wrapper')
          ? layout.settings.layout_type == 'rtl'
            ? { '  -right': margin + 'px' }
            : { 'margin-left': margin + 'px' }
          : { margin: '0px' },
      ]"
    >
      <li class="back-btn">
        <router-link to="/">
          <img
            class="img-fluid"
            src="../../assets/images/logo/logo-icon.png"
            alt=""
        /></router-link>
        <div class="mobile-back text-right">
          <span>Back</span
          ><i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
        </div>
      </li>
      <template v-for="(menuItem, index) in menuItems">
        
        <li
          :class="{
            active: menuItem.active,
            'sidebar-main-title': menuItem.type == 'headtitle',
          }"
          class="sidebar-list"
        >
          <!-- link title -->
          <div v-if="menuItem.type == 'headtitle'">
            <h6 class="lan-1">{{ $t(menuItem.headTitle1) }}</h6>
            <p class="lan-2">{{ $t(menuItem.headTitle2) }}</p>
          </div>
          <!-- Sub -->
          <label
            :class="'badge badge-' + menuItem.badgeType"
            v-if="menuItem.badgeType"
            >{{ $t(menuItem.badgeValue) }}</label
          >
          <a
            href="javascript:void(0)"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'sub'"
            @click="setNavActive(menuItem, index)"
          >
          <template v-if="menuItem.image">
              <img
                :src="require('@/assets/images/'+menuItem.image)"
                class="trailer-icon-margin"
              />
            </template>
            <template v-else-if="menuItem.fa_icon">
              <font-awesome-icon
                :icon="'fa-solid '  +menuItem.fa_icon"
                class="f-14"
                style="vertical-align: text-bottom"
              />
            </template>
            <template v-else>
            <feather :type="menuItem.icon" class="top"></feather>
            </template>

            <span> {{ $t(menuItem.title) }}</span>
            <div class="according-menu" v-if="menuItem.children">
              <i class="fa fa-angle-right pull-right"></i>
            </div>
          </a>
          
          <template v-if="menuItem.link_type">
              <a
                v-if="menuItem.title && menuItem.path"
                :href="menuItem.path"
                class="sidebar-link sidebar-title router-link-exact-active"
                :target="menuItem.target"
                :title="menuItem.title"
              >
                <font-awesome-icon
                  :icon="'fa-solid '+menuItem.fa_icon"
                  class="f-14"
                  style="vertical-align: text-bottom"
                />
                {{ menuItem.title }}
              </a>
          </template>
          <template v-else>
            <router-link
              :to="menuItem.path"
              class="sidebar-link sidebar-title"
              v-if="menuItem.type == 'link'"
              router-link-exact-active
              exact
              v-on:click.native="hidesecondmenu()"
            >
              <template v-if="menuItem.image">
                <img
                  :src="require('@/assets/images/'+menuItem.image)"
                  class="trailer-icon-margin"
                />
              </template>
              <template v-else-if="menuItem.fa_icon">
                <font-awesome-icon
                  :icon="'fa-solid '  +menuItem.fa_icon"
                  class="f-14"
                  style="vertical-align: text-bottom"
                />
              </template>
              <template v-else>
              <feather :type="menuItem.icon" class="top"></feather>
              </template>
              <span> {{ $t(menuItem.title) }} </span>
              <i
                class="fa fa-angle-right pull-right"
                v-if="menuItem.children"
              ></i>
            </router-link>
          </template>
          <!-- External Link -->
          <a
            :href="menuItem.path"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'extLink'"
            @click="setNavActive(menuItem, index)"
          >
          <template v-if="menuItem.image">
              <img
                :src="require('@/assets/images/'+menuItem.image)"
                class="trailer-icon-margin"
              />
            </template>
            <template v-else-if="menuItem.fa_icon">
              <font-awesome-icon
                :icon="'fa-solid '  +menuItem.fa_icon"
                class="f-14"
                style="vertical-align: text-bottom"
              />
              <i
              class="fa fa-angle-right pull-right"
              v-if="menuItem.children"
            ></i>
            </template>
            <template v-else>
            <feather :type="menuItem.icon" class="top"></feather>
            </template>
            
            <span> {{ $t(menuItem.title) }} </span>
            <i
              class="fa fa-angle-right pull-right"
              v-if="menuItem.children"
            ></i>
          </a>
          <!-- External Tab Link -->
          <a
            :href="menuItem.path"
            target="_blank"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'extTabLink'"
            @click="setNavActive(menuItem, index)"
          >
          <template v-if="menuItem.image">
              <img
                :src="require('@/assets/images/'+menuItem.image)"
                class="trailer-icon-margin"
              />
            </template>
            <template v-else-if="menuItem.fa_icon">
              <font-awesome-icon
                :icon="'fa-solid '  +menuItem.fa_icon"
                class="f-14"
                style="vertical-align: text-bottom"
              />
            </template>
            <template v-else>
              <feather :type="menuItem.icon" class="top"></feather>
            </template>
            <span> {{ $t(menuItem.title) }} </span>
            <i
              class="fa fa-angle-right pull-right"
              v-if="menuItem.children"
            ></i>
          </a>
          <!-- 2nd Level Menu -->
          <ul
            class="sidebar-submenu"
            v-if="menuItem.children"
            :class="{ 'menu-open': menuItem.active }"
          >
            <template>
              <li
                v-for="(childrenItem, index) in menuItem.children"
                :key="index"
                :class="{ active: childrenItem.active }"
              >
                <!-- Sub -->
                <a
                  class="submenu-title"
                  href="javascript:void(0)"
                  v-if="childrenItem.type == 'sub'"
                  @click="setNavActive(childrenItem, index)"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ childrenItem.badgeValue }}</label
                  >
                  <i
                    class="fa pull-right mt-1"
                    v-bind:class="[
                      childrenItem.active
                        ? 'fa fa-angle-down'
                        : 'fa fa-angle-right',
                    ]"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- Link -->
                <router-link
                  class="submenu-title"
                  :to="childrenItem.path"
                  v-if="childrenItem.type == 'link'"
                  router-link-exact-active
                  exact
                  v-on:click.native="hidesecondmenu()"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right mt-1"
                    v-if="childrenItem.children"
                  ></i>
                </router-link>
                <!-- External Link -->
                <a
                  :href="childrenItem.path"
                  v-if="childrenItem.type == 'extLink'"
                  class="submenu-title"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right mt-1"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- External Tab Link -->
                <a
                  class="submenu-title"
                  :href="childrenItem.path"
                  target="_blank"
                  v-if="childrenItem.type == 'extTabLink'"
                >
                  {{ $t(childrenItem.title) }}
                  <label
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</label
                  >
                  <i
                    class="fa fa-angle-right pull-right mt-1"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- 3rd Level Menu -->
                <ul
                  class="nav-sub-childmenu submenu-content"
                  v-if="childrenItem.children"
                  :class="{ opensubchild: childrenItem.active }"
                >
                  <li
                    v-for="(childrenSubItem, index) in childrenItem.children"
                    :key="index"
                  >
                    <!-- Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'link'"
                      router-link-exact-active
                      exact
                      v-on:click.native="hidesecondmenu()"
                    >
                      {{ $t(childrenSubItem.title) }}
                      <label
                        :class="
                          'badge badge-' +
                          childrenSubItem.badgeType +
                          ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</label
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                    <!-- External Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'extLink'"
                      router-link-exact-active
                    >
                      {{ $t(childrenSubItem.title) }}
                      <label
                        :class="
                          'badge badge-' +
                          childrenSubItem.badgeType +
                          ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</label
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                    <!-- External Tab Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'extLink'"
                      router-link-exact-active
                    >
                      {{ $t(childrenSubItem.title) }}
                      <label
                        :class="
                          'badge badge-' +
                          childrenSubItem.badgeType +
                          ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</label
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                  </li>
                </ul>
              </li>
            </template>
          </ul>
        </li>
      </template>
    </ul>
    <div class="poweredBy">
      Powered by
      <img
        src="@/assets/images/logo.png"
        class="img-fluid for-light1"
        style="width: 100px"
      />
    </div>
  </div>
</template>
<script>
  import { mapState } from "vuex";
  import { layoutClasses } from "../../constants/layout";
  import Axios from "axios";
  export default {
    name: "Navmenu",
    data() {
      return {
        layoutobj: {},
        ExternalLinks: [],
        hgvModule: false,
        trailersModule: false,
        reportModule: false,
        fuelTrackingModule: false,
        auditModule: false,
        assetsModule: false,
        VehicleClasses: [],
        VehicleInspectionClasses: [],
        AssetTemplates: [],
        ShowVehicle: false,
        ShowTrailer: false,
        ShowAssets: false,
        showReports: false,
        ShowFuelTracking: false,
        showAuditLogs: false,
        ShowDriver: false,
        ShowVehicleChecks: false,
        ShowVehicleInspections: false,
        ShowSettings: false,
        ShowDocuments: false,
        ShowBranches: false,
        ShowCategory: false,
        ShowLocation: false,
        ShowAccountRoles: false,
        ShowUsers: false,
        ParentIndex: false,
        AccountRoles: [],
        FleetSubscriptionModules: [],
        ShowVehicleChecksMenu: false,
        ShowVehicleInspectionsMenu: false,
        ShowAssetChecksMenu: false,
        ShowNotifications: false,
        menuItems:[
          {
            "headTitle1": "Welcome",
            "headTitle2": "To Pocket Box Fleet",
            "type": "headtitle"      
          },
          {
            "path": "/",
            "title": "Dashboard",
            "icon": "home",
            "type": "link",
            "active": false
        }
        ]
      };
    },
    computed: {
      ...mapState({
       // menuItems: (state) => state.menu.data,
        layout: (state) => state.layout.layout,
        sidebar: (state) => state.layout.sidebarType,
        activeoverlay: (state) => state.menu.activeoverlay,
        togglesidebar: (state) => state.menu.togglesidebar,
        width: (state) => state.menu.width,
        height: (state) => state.menu.height,
        margin: (state) => state.menu.margin,
        menuWidth: (state) => state.menu.menuWidth,
      }),
      layoutobject: {
        get: function () {
          return JSON.parse(
            JSON.stringify(
              layoutClasses.find(
                (item) =>
                  Object.keys(item).pop() === this.layout.settings.layout
              )
            )
          )[this.layout.settings.layout];
        },
        set: function () {
          this.layoutobj = layoutClasses.find(
            (item) => Object.keys(item).pop() === this.layout.settings.layout
          );
          this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
            this.layout.settings.layout
          ];
          return this.layoutobj;
        },
      },
    },
    watch: {
      width() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
        if (window.innerWidth < 992) {
          const newlayout = JSON.parse(
            JSON.stringify(this.layoutobject).replace(
              "horizontal-wrapper",
              "compact-wrapper"
            )
          );
          document.querySelector(".page-wrapper").className =
            "page-wrapper " + newlayout;
          //this.$store.state.menu.margin = 0;
        } else {
          document.querySelector(".page-wrapper").className =
            "page-wrapper " + this.layoutobject;
        }

        if (
          (window.innerWidth < 1199 &&
            this.layout.settings.layout === "Tokyo") ||
          (window.innerWidth < 1199 &&
            this.layout.settings.layout === "Moscow") ||
          (window.innerWidth < 1199 && this.layout.settings.layout === "Rome")
        ) {
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
        }
      },
    },
    created() {
      var Company = JSON.parse(localStorage.getItem("Company"));
      /*if(Company && Company.name){
        this.menuItems[0]['headTitle2']='To '+Company.name;
      } */
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      if (this.$store.state.menu.width < 991) {
        this.layout.settings.layout = "Dubai";
        //this.margin = 0;
      }
      setTimeout(() => {
        const elmnt = document.getElementById("myDIV");
        if (!elmnt) return;
        
        this.$store.state.menu.menuWidth = elmnt.offsetWidth;
        this.$store.state.menu.menuWidth > window.innerWidth
          ? ((this.$store.state.menu.hideRightArrow = false),
            (this.$store.state.menu.hideLeftArrowRTL = false))
          : ((this.$store.state.menu.hideRightArrow = false),
            (this.$store.state.menu.hideLeftArrowRTL = true));
      }, 500);
      this.layoutobject = layoutClasses.find(
        (item) => Object.keys(item).pop() === this.layout.settings.layout
      );
      this.layoutobject = JSON.parse(JSON.stringify(this.layoutobject))[
        this.layout.settings.layout
      ];
    },
    destroyed() {
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.$root.$on("reloadVehicleClass", () => {
        this.GetVehicleClass();
      });
      this.$root.$on("reloadInspectionClass", () => {
        this.GetVehicleInspectionClass();
      });

      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var AccountRoles = JSON.parse(localStorage.getItem("permissions"));
      if (AccountPermissions) {
        this.ShowVehicle = (AccountPermissions?.Vehicle && AccountPermissions?.Vehicle?.enable);
        this.ShowTrailer = (AccountPermissions?.Trailers && AccountPermissions?.Trailers?.enable);        
        this.ShowAssets = (AccountPermissions?.Assets && AccountPermissions?.Assets?.enable);
        this.showReports = (AccountPermissions?.Reports && AccountPermissions?.Reports?.enable);
        this.ShowDriver = (AccountPermissions?.Driver && AccountPermissions?.Driver?.enable);
        this.ShowDocuments = (AccountPermissions?.Documents && AccountPermissions?.Documents?.enable);
        this.ShowSettings = (AccountPermissions?.Settings && AccountPermissions?.Settings?.enable);
        this.ShowBranches = (AccountPermissions?.Branches && AccountPermissions?.Branches?.enable);
        this.ShowCategory = (AccountPermissions?.Category && AccountPermissions?.Category?.enable);
        this.ShowLocation = (AccountPermissions?.Location && AccountPermissions?.Location?.enable);
        this.ShowVehicleInspections = (AccountPermissions?.HGV && AccountPermissions?.HGV?.enable);

        this.ShowFuelTracking =  (AccountPermissions["Fuel Tracking"] && AccountPermissions["Fuel Tracking"]["enable"]);        
        this.showAuditLogs =  (AccountPermissions["Audit Log"] && AccountPermissions["Audit Log"]["enable"]);
        this.ShowVehicleChecks =  (AccountPermissions["Vehicle Checks"] && AccountPermissions["Vehicle Checks"]["enable"]);
      }

      this.ShowAccountRoles = (FleetSubscriptionModules["Hierarchy System"] && AccountRoles.fleet_role_id === 1);
      this.ShowUsers = (AccountRoles.fleet_role_id === 1);
      this.ShowNotifications = (FleetSubscriptionModules["Notifications"] && AccountRoles.fleet_role_id === 1);


      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowTrailer = true;
        this.ShowAssets = true;
        this.ShowVehicle = true;
        this.ShowDocuments = true;
        this.showReports = true;
        this.showAuditLogs = true;
        this.ShowDriver = true;
        this.ShowVehicleChecks = true;
        this.ShowVehicleInspections = true;
        this.ShowSettings = true;
        this.ShowBranches = true;
        this.ShowCategory = true;
        this.ShowLocation = true;
        this.ShowFuelTracking = true;
      }
      var FleetSubscriptionModules = JSON.parse(
          JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
        );
        this.hgvModule = FleetSubscriptionModules.HGV;
        this.reportModule = FleetSubscriptionModules.Reports;
        this.auditModule = FleetSubscriptionModules["Audit Log"];
        this.assetsModule = FleetSubscriptionModules.Assets;
        this.trailersModule = FleetSubscriptionModules.Trailers;
        this.fuelTrackingModule = FleetSubscriptionModules["Fuel Tracking"];

      if (this.ShowVehicle) {
          this.menuItems.push({
            "path": "/vehicles-list",
            "title": "Vehicles",
            "icon": "truck",
            "type": "link",
            "active": false
        });
      } 

      if (this.trailersModule && this.ShowTrailer) {
          this.menuItems.push({
            "path": "/trailers-list",
            "title": "Trailers",
            "icon": "truck",
            "type": "link",
            "image":'trailer.png',
            "active": false
        });
      }
      if (this.assetsModule && this.ShowAssets) {
          this.menuItems.push({
            "path": "/assets/list",
            "title": "Assets",
            "icon": "list",
            "type": "link",
            "image":'crane.png',
            "active": false
        });
      }
      if (this.ShowDriver) {
        this.menuItems.push({
            "path": "/drivers-list",
            "title": "Drivers",
            "icon": "users",
            "type": "link",
            "active": false
        });
      }
      if (this.fuelTrackingModule && this.ShowFuelTracking) {
        this.menuItems.push({
            "path": "/fuel",
            "title": "Fuel",
            "icon": "list",
            "fa_icon": "fa-zap",
            "type": "link",
            "active": false
        });
      }
      if (this.ShowDocuments) {
          this.menuItems.push({
            "path": "/documents",
            "title": "Documents",
            "icon": "file",
            "type": "link",
            "active": false
        });
      }

      var vehicleChecksSubmenu = [];
      if (this.ShowVehicleChecks ) {
        this.menuItems.push(
          {
            "path": "/vehicle-checks",
            "title": "Vehicle Checks",
            "icon": "user-check",
            "type": "sub",
            "active": false,
            "children":vehicleChecksSubmenu
        }
        );
      }
  
      if (this.ShowVehicleInspections && this.hgvModule 
      ) {
        this.menuItems.push({
        "path": "/vehicle-inspections",
        "title": "Vehicle Inspections",
        "icon": "list",
        "fa_icon" : "fa-life-ring",
        "type": "sub",
        "active": false,
        "children":[]
        });
      }
    if (this.assetsModule && this.ShowAssets
      ) {
        this.menuItems.push({
          "path": "/asset-checks",
          "title": "Asset Checks",
          "icon": "list",
          "fa_icon": "fa-calendar-check",
          "type": "sub",
          "active": false,
          "children":[]
        });
      }
      if (this.reportModule && this.showReports) {
        this.menuItems.push({
            "path": "/reports",
            "title": "Reports",
            "icon": "users",
            "fa_icon" : 'fa-chart-pie',
            "type": "link",
            "active": false
        });
      }

      var settingsChildren = [];
      if (this.ShowSettings) {
        settingsChildren.push({
          "path": "/settings",
          "title": "Settings",
          "icon": "table",
          "type": "link",
          "active": false
        });
      }
      if (this.ShowBranches) {
        settingsChildren.push({
          "path": "/branches",
          "title": "Branches",
          "icon": "table",
          "type": "link",
          "active": false
        });
      }

      if (this.auditModule && this.showAuditLogs) {
        settingsChildren.push({
            "path": "/auditlog",
            "title": "Audit Log",
            "icon": "list",
            "fa_icon" : 'fa-chart-line',
            "type": "link",
            "active": false
        });
      }
      if (this.ShowAccountRoles) {
            settingsChildren.push({
              "path": "/account-roles",
              "title": "Roles",
              "icon": "gears",
              "fa_icon": "fa-gears",
              "type": "link",
              "active": false
            });
      }
      if (this.ShowUsers) {
        settingsChildren.push(
            {
              "path": "/users",
              "title": "Users",
              "icon": "table",
              "type": "link",
              "active": false
            },{
              "path": "/company-details",
              "title": "Company",
              "icon": "table",
              "type": "link",
              "active": false
            });
      }
      if (this.ShowNotifications) {
        settingsChildren.push(
            {
              "path": "/email-preferences",
              "title": "Notifications",
              "icon": "list",
              "type": "link",
              "active": false
            });
      }
      settingsChildren.push({
            "path": "/settings/import-excel",
            "title": "Bulk Import",
            "icon": "table",
            "type": "link",
            "active": false
          },
          {
            "path": "/reports-table",
            "title": "Reporting",
            "icon": "table",
            "type": "link",
            "active": false
          },
          {
            "path": "/groups",
            "title": "Groups",
            "icon": "table",
            "type": "link",
            "active": false
          });
      
      this.menuItems.push({
          "path": "/settings",
          "title": "Settings",
          "icon": "settings",
          "type": "sub",
          "active": false,
          "children":settingsChildren
        });
        var assetChildren = [
          {
              "path": "/asset/settings",
              "title": "Asset Settings",
              "icon": "table",
              "type": "link",
              "active": false
            },
          {
              "path": "/asset/templates",
              "title": "Asset Templates",
              "icon": "table",
              "type": "link",
              "active": false
            },
            {
              "path": "/assets/group",
              "title": "Group",
              "icon": "table",
              "type": "link",
              "active": false
            },
            {
              "path": "/assets/ownership",
              "title": "Ownership",
              "icon": "table",
              "type": "link",
              "active": false
            }
        ];
        if (this.ShowLocation) {
            assetChildren.push({
                "path": "/assets/location",
                "title": "Location",
                "icon": "table",
                "type": "link",
                "active": false
              });
        }
        if (this.ShowCategory) {
          assetChildren.push({
              "path": "/assets/category",
              "title": "Category",
              "icon": "table",
              "type": "link",
              "active": false
            });
        }
        if(this.assetsModule){
          this.menuItems.push(
              {
                "path": "/assets",
                "title": "Assets Setting",
                "icon": "map",
                "type": "sub",
                "active": false,
                "children":assetChildren
          });
        }
        this.menuItems.push({
            "path": "https://pocketbox.co.uk/fleet-help",
            "title": "Help",
            "icon": "truck",
            "type": "link",
            "fa_icon": "fa-life-ring",
            "target":"_blank",
            "link_type":"external",
            "active": false
        },{
            "path": "https://www.pocketbox.co.uk/marketplace",
            "title": "Marketplace",
            "icon": "truck",
            "type": "link",
            "fa_icon": "fa-bullhorn",
            "target":"_blank",
            "link_type":"external",
            "active": false
        });
      this.menuItems.filter((items) => {
        if (items.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", items);
        if (!items.children) return false;
        items.children.filter((subItems) => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch("menu/setActiveRoute", subSubItems);
          });
        });
      });
      
      this.GetCompanyDetail();
      this.GetVehicleClass();
      if (this.ShowVehicleInspections && this.hgvModule) {
        this.GetVehicleInspectionClass();
      }
      this.GetAssetTemplates();
    },
    methods: {
      GetVehicleClass() {
        var self = this;
        var obj = { token: localStorage.getItem("token") };
        obj.type = "LeftNavigation";
        Axios.post(Endpoints.Vehicle.GetVehicleTypes, obj).then((Response) => {
          if (Response?.data?.success) {
            if (Object.keys(Response.data.records).length > 0) {
              Object.values(Response.data.records).forEach((classItem) => {
                self.VehicleClasses.push(classItem);
              });
              this.setChecksSubMenu("Vehicle Checks",this.VehicleClasses, '/vehicle-checks/','title');
            } else {
              if (localStorage.getItem("Classes")) {
                this.VehicleClasses = JSON.parse(
                  localStorage.getItem("Classes")
                );
                this.setChecksSubMenu("Vehicle Checks",this.VehicleClasses, '/vehicle-checks/','title');
              } else {
                Axios.post(Endpoints.VehicleChecks.GetVehicleClassList, {
                  token: localStorage.getItem("token"),
                }).then((Response) => {
                  if (Response?.data?.success) {
                    this.VehicleClasses = Response.data.records;
                    localStorage.setItem(
                      "Classes",
                      JSON.stringify(Response.data.records)
                    );
                  }
                });
                this.setChecksSubMenu("Vehicle Checks",this.VehicleClasses, '/vehicle-checks/','title');                
              }
            }
          }
        });
      },
      GetVehicleInspectionClass() {
        if (localStorage.getItem("InspectionsClasses")) {
          this.VehicleInspectionClasses = JSON.parse(
            localStorage.getItem("InspectionsClasses")
          );
          if(this.VehicleInspectionClasses.length > 0){
            this.setChecksSubMenu("Vehicle Inspections",this.VehicleInspectionClasses, '/vehicle-inspections/','title');
          }

        } else {
          Axios.post(Endpoints.VehicleInspections.GetVehicleClasses, {
            token: localStorage.getItem("token"),
          }).then((Response) => {
            if (Response?.data?.success) {
              this.VehicleInspectionClasses = Response.data.records;
              localStorage.setItem(
                "InspectionsClasses",
                JSON.stringify(Response.data.records)
              );
              this.setChecksSubMenu("Vehicle Inspections",this.VehicleInspectionClasses, '/vehicle-inspections/','title');
            }
          });
        }
      },
      GetAssetTemplates(){
        if (localStorage.getItem("AssetTemplates")) {
          this.AssetTemplates = JSON.parse(
            localStorage.getItem("AssetTemplates")
          );
          if(this.AssetTemplates.length > 0){            
            this.setChecksSubMenu("Asset Checks",this.AssetTemplates, '/asset-checks/','subcategory_name');
          }else{
            this.GetAssetTemplatesList();
          }
        } else {
          this.GetAssetTemplatesList();
        }
      },
      GetAssetTemplatesList(){
        Axios.post(Endpoints.Assets.Template.List, {
            token: localStorage.getItem("token"),
          }).then((Response) => {
            if (Response?.data?.success) {
              this.AssetTemplates = Response.data.Templates;
              localStorage.setItem(
                "AssetTemplates",
                JSON.stringify(Response.data.Templates)
              );
             this.setChecksSubMenu("Asset Checks",this.AssetTemplates, '/asset-checks/','subcategory_name');
            }
          });
      },
      setChecksSubMenu
      (type, records,url,field_name){
        let Index = this.menuItems.map((menu) => menu.title).indexOf(type);

        if (Index === -1) {
          return; // menu not exist
        }

        if(records.length > 0 && this.ShowVehicle){
            var ChecksChild = []; 
            records.forEach((record) => {
              ChecksChild.push({
                  "path": url + record.id,
                  "title": record[field_name],
                  "icon": "table",
                  "type": "link",
                  "active": false
              });
            });
            this.menuItems[Index]["children"] = ChecksChild;
          }else{
            this.menuItems.splice(Index, 1);
          }
      },
      GetCompanyDetail() {
        var CompanyData = JSON.parse(localStorage.getItem("Company"));
        if (
          CompanyData.fleet_settings_key != "" &&
          CompanyData.fleet_settings_key != null
        ) {
          var CompanySettingsKey = JSON.parse(CompanyData.fleet_settings_key);
          if (typeof CompanySettingsKey.ExternalLinks != "undefined") {
            this.ExternalLinks = CompanySettingsKey.ExternalLinks;
            if(this.ExternalLinks.length > 0){
              this.ExternalLinks.forEach((CompanyLink) => {
                if(CompanyLink.title != ''){
                  var path = CompanyLink.link;
                  var target = '_blank';
                  var fa_icon = "fa-solid fa-link";
                  if(CompanyLink.iframe){
                    path = '/external-links/sidebar/' + this.getTitle(CompanyLink.title);
                    target = '_self';
                  }
                  if(CompanyLink.icon && CompanyLink.icon.name){
                    var fa_icon = 'fa-solid fa-' + CompanyLink.icon.name;
                  }
                  this.menuItems.push({
                      "path": path,
                      "title": CompanyLink.title,
                      "icon": "truck",
                      "type": "link",
                      "fa_icon": fa_icon,
                      "target":target,
                      "link_type":"external",
                      "active": false
                  });
                }
              });
            }
          }
        }
      },
      handleScroll() {
        if (window.scrollY > 400) {
          if (
            this.layoutobject.split(" ").pop() === "material-type" ||
            this.layoutobject.split(" ").pop() === "advance-layout"
          )
            document.querySelector(".sidebar-main").className =
              "sidebar-main hovered";
        } else {
          if (document.getElementById("sidebar-main"))
            document.querySelector(".sidebar-main").className = "sidebar-main";
        }
      },
      setNavActive(item) {
        this.$store.dispatch("menu/setNavActive", item);
        if (
          this.layoutobject.split(" ").includes("compact-sidebar") &&
          window.innerWidth > 991
        ) {
          if (this.menuItems.some((menuItem) => menuItem.active === true)) {
            this.$store.state.menu.activeoverlay = true;
          } else {
            this.$store.state.menu.activeoverlay = false;
          }
        }
      },
      hidesecondmenu() {
        if (window.innerWidth < 991) {
          this.$store.state.menu.activeoverlay = false;
          this.$store.state.menu.togglesidebar = false;
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
        } else if (this.layoutobject.split(" ").includes("compact-sidebar")) {
          this.$store.state.menu.activeoverlay = false;
          this.menuItems.filter((menuItem) => {
            menuItem.active = false;
          });
        }
      },
      handleResize() {
        this.$store.state.menu.width = window.innerWidth - 450;
      },
      getTitle(title) {
        return title
          .replace(/(?!\w|\s)./g, "-")
          .replace(/\s+/g, "-")
          .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
          .toLowerCase();
      },
    },
  };
</script>
<style scoped>
  .submenu-title {
    font-size: 12px !important;
  }
.poweredBy {
  background: #fff;
  display: block;
  width: 100%;
  position: absolute;
  bottom: 10px;
  text-align: center;
  padding: 10px 10px 10px 0;
  border-top: 1px solid #d3d3d3;
  z-index: 100;
}
.poweredBy img {
  clear: both;
  display: block;
  margin: 0px auto;
}
#myDIV{
  padding-bottom: 56px;
}
@media screen and (max-width: 1080px){
  .poweredBy {
    bottom: 0px;
  }
  #myDIV{
    padding-bottom: 100px;
  }
}
</style>